import React from 'react';
import { Grid } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import {
	DetailsSectionDescription,
	DetailsSectionFlow,
	DetailsSectionInfoWrapper,
	type DetailsPageContentProps
} from 'app/main/components/page-layouts';
import DetailsSectionNotes from 'app/main/submodules/notes/DetailsSectionNotes';

import WorkReportsDetailsSectionInfo from '../sections/WorkReportsDetailsSectionInfo';
import WorkReportsDetailsSectionSecondaryInfo from '../sections/WorkReportsDetailsSectionSecondaryInfo';

export default function WorkReportsDetailsTab(props: DetailsPageContentProps) {
	const { t } = useSettings();

	return (
		<Grid container spacing={2}>
			<Grid size={{ lg: 8, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="text-subject" />}
							title={t('DETAILS_INFO_SECTION')}
							subheader={t('DETAILS_INFO_SUBHEADER')}
						>
							<WorkReportsDetailsSectionInfo
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="text-subject" />}
							title={t('DETAILS_SECONDARY_INFO_SECTION')}
							subheader={t('DETAILS_SECONDARY_INFO_SUBHEADER')}
						>
							<WorkReportsDetailsSectionSecondaryInfo
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					<Grid size={12}>
						<DetailsSectionDescription
							name="wore_descriptionhtml"
							value={props.model.wore_descriptionhtml}
							isEdit={props.isEdit}
							logProps={props.logProps}
							sendChange={props.sendChange}
						/>
					</Grid>
					<Grid size={12}>
						<DetailsSectionNotes module="workreports" uid={props.model.wore_uid} />
					</Grid>
				</Grid>
			</Grid>
			<Grid size={{ lg: 4, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionFlow
							module="workreports"
							model={props.model}
							isEdit={props.isEdit}
							sendChange={props.sendChange}
							logProps={props.logProps}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}
